import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { CustomValidators } from 'ng2-validation';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { environment } from 'environments/environment.prod';
import { httpservice } from 'http/http';
const breadcrumb: any[] = [
  {
    title: 'Home'
 
  },
  {
    title: 'Supplier'
   
  },
  {
    title: 'Edit supplier'
   
  }
];

//const password = new FormControl('', Validators.required);
//const confirmPassword = new FormControl('', CustomValidators.equalTo(password));

@Component({
  selector: 'page-supplier-form-edit',
  templateUrl: './supplier-form-edit.html',
  styleUrls: ['./supplier-form-edit.scss']
})


export class PageSupplierEdit implements OnInit {
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  public form: FormGroup;
  data: any;

  
  //diaglog
  dialogRef: MdDialogRef<SupplierEditDialog>;
  selectedOption: string;

  tb2_id:string;
  tb2f_id:string;
  rows=[]
  arrContact=[];
  fullname:string;
  shortname:string;
  contactName:string;
  email:string;
  phone:string;
  website:string;
  address:string;
  taxid:string;
  branch:string;
  gIndex: any = null; gIndexCk: boolean = false;
  ckNullContact: boolean = false;
  constructor(private httpservice:httpservice,private activatedRoute: ActivatedRoute,public dialog: MdDialog,private fb: FormBuilder, private _sharedService: SharedService,private router: Router) {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.tb2_id = params['id'];
      this.getDataStart();
      console.log('--id--',this.tb2_id);
    });
    this._sharedService.emitChange(this.pageTitle);
  } 
  add(){
    let value = {
      contactname:this.form.controls.contactname.value,
      phone:this.form.controls.phone.value,
      email:this.form.controls.email.value,
      department:this.form.controls.department.value,
      tb2_id:this.tb2_id
    }
    
    this.httpservice.fetchpost('insertDataPostSupplierContact.php',value,data=>{
      this.form.controls.contactname.reset();
      this.form.controls.phone.reset();
      this.form.controls.email.reset();
      this.form.controls.department.reset();
      this.getDataStart();

    });
  }

  setEdit(id:any,index: any) {
    this.tb2f_id = id;
    this.gIndexCk=true;
    this.form.controls.contactname.setValue(this.rows[index].tb2f_name);
    this.form.controls.email.setValue(this.rows[index].tb2f_email);
    this.form.controls.phone.setValue(this.rows[index].tb2f_phone);
    this.form.controls.department.setValue(this.rows[index].tb2f_department);
  }

  edit() {
    let dialogRef = this.dialog.open(supplierLoadingEditDialog, { disableClose: true });
    let instance = dialogRef.componentInstance;
    instance.Message = "wait.....";
    let value = {
      tb2f_name: this.form.controls.contactname.value,
      tb2f_phone: this.form.controls.phone.value,
      tb2f_email: this.form.controls.email.value,
      tb2f_department: this.form.controls.department.value,
      id:this.tb2f_id
    }

    this.httpservice.fetchpost('editSupplierContact.php',value,(cb)=>{
      this.getDataStart();
      this.gIndexCk = false;
      this.form.controls.contactname.reset();
      this.form.controls.phone.reset();
      this.form.controls.email.reset();
      this.form.controls.department.reset();
      this.dialog.closeAll();
    });
  
  }
  openDialogDelete(id:String) {
    let dialogRef = this.dialog.open(SupplierEditDialog);
     dialogRef.afterClosed().subscribe(result => {
      if(result==='1'){
        this.delete(id);
      }else{
      }
    });
  }

  delete(id:String){
    let dialogRef = this.dialog.open(supplierLoadingEditDialog, { disableClose: true });
    let instance = dialogRef.componentInstance;
    instance.Message = "wait.....";
    let value = {id:id};
    this.httpservice.fetchpost('deleteDataSupplierContact.php',value,cb=>{
      this.getDataStart();
      this.dialog.closeAll();
    });
  }

  getDataStart(){
    let dialogRef = this.dialog.open(supplierLoadingEditDialog, { disableClose: true });
    let instance = dialogRef.componentInstance;
    instance.Message = "wait.....";
  
    this.httpservice.fetchget('getJSON_supplier.php?id='+this.tb2_id,data=>{
      this.form.controls.branch.setValue(data[0].tb2_branch),
      this.form.controls.taxid.setValue(data[0].tb2_taxid),
      this.form.controls.address.setValue(data[0].tb2_address),
      this.form.controls.shortname.setValue(data[0].tb2_company_shortname),
      this.form.controls.fullname.setValue(data[0].tb2_company_fullname),
      this.form.controls.website.setValue(data[0].tb2_website)

      this.rows = data[0].arrContact;
      this.dialog.closeAll();

    });
  }


    openDialog() {
    let dialogRef = this.dialog.open(SupplierEditDialog);
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      
      if(result==='1'){
        this.postString();
        console.log('---result---',result);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }

    });
  }
  postString() {
    let dialogRef = this.dialog.open(supplierLoadingEditDialog, { disableClose: true });
    let instance = dialogRef.componentInstance;
    instance.Message = "wait.....";

    let value = {
      branch:this.form.controls.branch.value,
      taxid:this.form.controls.taxid.value,
      address:this.form.controls.address.value,
      id:this.tb2_id,
      shortname:this.form.controls.shortname.value.replace(/&/g, '^'),
      fullname:this.form.controls.fullname.value.replace(/&/g, '^'),
      website:this.form.controls.website.value
    };

    this.httpservice.fetchpost('editSupplier.php',value,cb=>{
      this.dialog.closeAll();
      this.router.navigateByUrl('default-layout/supplier');

    });

  }

  ngOnInit() {
    this.form = this.fb.group({
      //stateCtrl: [null, Validators.compose([Validators.required])],
      shortname: [null, Validators.compose([Validators.required])],
      fullname: [null, Validators.compose([Validators.required])],
      contactname: [null, Validators.compose([Validators.required])],
      phone: [null, Validators.compose([Validators.required])],
      email: [null, Validators.compose([Validators.required])],
      website: [null, Validators.compose([Validators.required])],
      address: [null, Validators.compose([Validators.required])],
      taxid: [null, Validators.compose([Validators.required])],
      branch: [null, Validators.compose([Validators.required])],
      department:[null, Validators.compose([Validators.required])]
    });
  }
}

//dialog
@Component({
  selector: 'supplier-dialog',
  templateUrl: 'supplier-dialog.html',
})
export class SupplierEditDialog {
  Message = 'What would you like to do?';
  constructor(public dialogRef: MdDialogRef<SupplierEditDialog>) {}
}
//dialog
@Component({
  selector: 'loading-dialog',
  templateUrl: 'loading-dialog.html',
})
export class supplierLoadingEditDialog {
  Message = '';
  Title = '';
  constructor(public dialogRef: MdDialogRef<supplierLoadingEditDialog>) { }
}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/supplier/supplier-form-edit.ts